<!--
@author: 赵静静
@time: 2021/10/28
@desc:  工种弹窗
-->
<template>
  <div class="workTypesList">
    <el-dialog
      title="请选择工种"
      :visible.sync="isShowVisible"
      width="60vw"
      center
      class="workTypesPopupStyle"
      :close-on-click-modal="false"
      :before-close="() => $emit('close')">
      <el-checkbox-group v-model="values" @change="selectGongZhongLabel">
        <div v-for="worker in typOfWorks" v-if="worker.categoryName !== '热门工种'">
          <div class="worker-title">{{ worker.categoryName }}</div>
          <el-checkbox-button v-for="item in worker.typeOfWorks" :label="item.id" :key="item.id">{{
              item.name
            }}
          </el-checkbox-button>
        </div>


      </el-checkbox-group>


      <div slot="footer">
        <el-button type="info" @click="closeModal" class="btnHeight_40 btWith_120">取消</el-button>
        <el-button type="primary" @click="selectWorkTypes" class="btnHeight_40 btWith_120">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getWorkList} from '@api/public'
import {listTypeOfWork} from "@api/home";

export default {
  name: 'workTypes',
  props: ['List'],
  data() {
    return {
      isShowVisible: true,
      gongZhongList: [],
      values: [],
      labels: [],
      typOfWorks: []
    }
  },
  mounted() {
    this.getWorkList()

    this.listTypeOfWork()
    this.values = this.List
  },
  methods: {
    // 获取工种
    getWorkList() {
      getWorkList().then(res => {
        if (res.data.code === 200) {
          this.gongZhongList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 获取工种列表
    listTypeOfWork() {
      listTypeOfWork().then(res => {
        if (res.data.code === 200) {
          this.typOfWorks = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    closeModal() {
      this.values = []
      this.$emit('close')
    },
    selectWorkTypes() {
      if (this.values.length > 5) {
        this.$message.error('最多选择5个工种')
        return false
      }
      this.$emit('workTypesValues', this.values)
      this.$emit('workTypesLabels', this.labels)
      this.closeModal()
    },
    selectGongZhongLabel(data) {
      if (this.values.length > 5) {
        this.values = this.values.slice(0, 5)
        this.$message.error('最多选择5个工种')
        return false
      }
      this.labels = []
      data.forEach(item => {
        this.gongZhongList.map(val => {
          if (item === val.id) {
            this.labels.push(val.name)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.workTypesPopupStyle {

  .worker-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 10px;
  }

  .el-checkbox-button__inner {
    margin-right: 24px;
    border-radius: 30px !important;
    padding: 0 10px 0 0;
    margin-bottom: 12px;
    border: 0px solid #DCDFE6 !important;
    border-left: 0px solid #DCDFE6 !important;
  }

  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #096cef;
    background-color: #ffffff;
    border-color: #ffffff;
    border: 0px solid #FCB040 !important;
    border-left: 0px solid #FCB040 !important;
    box-shadow: 0 0 0 0 #8cc5ff;
  }
}
</style>
